import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";

const ProductQuickView = ({ show, onHide, product }) => {
  const placeholderImage = "https://via.placeholder.com/150";
  const [showFullDescription, setShowFullDescription] = useState(false);
  const navigate = useNavigate();

  if (!product) return null;

  // Determine main image URL
  const imageUrl = (
    product.color_image ||
    product.product_image ||
    product.images?.[0]?.image ||
    placeholderImage
  ).replace("http://39.61.51.195:8004/", "https://dehleze.shop/");
  console.log("Image URL:", product.id);

  const getShortDescription = (description) => {
    const words = description?.split(" ") || [];
    if (words.length <= 50) return description;

    const shortText = words.slice(0, 50).join(" ");
    return showFullDescription ? description : `${shortText}... `;
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{product.name || "Product Details"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          {/* Left Section: Product Images */}
          <div className="col-12 col-md-6 mb-3">
            <img
              src={imageUrl}
              alt={product.name}
              className="img-fluid mb-3 w-100"
              style={{ objectFit: "cover", maxHeight: "300px" }}
            />
            <div className="d-flex justify-content-center flex-wrap">
              {product.images?.map((img, index) => {
                const thumbUrl = (
                  img.image ||
                  product.color_image ||
                  product.product_image ||
                  placeholderImage
                ).replace("http://39.61.51.195:8004/", "https://dehleze.shop/");
                return (
                  <img
                    key={index}
                    src={thumbUrl}
                    alt={`Thumbnail ${index + 1}`}
                    className="img-thumbnail m-1"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                  />
                );
              })}
            </div>
          </div>

          {/* Right Section: Product Info */}
          <div className="col-12 col-md-6">
            <p>
              <strong>Price:</strong>{" "}
              <span
                style={{ color: "#ff4444", textDecoration: "line-through" }}
              >
                PKR {product.price}
              </span>{" "}
              <span style={{ color: "#28a745" }}>
                PKR{" "}
                {(
                  product.price -
                  product.price * (product.discount_percentage / 100)
                ).toFixed(2)}{" "}
                ({product.discount_percentage}% off)
              </span>
            </p>
            <p>
              <strong>In Stock:</strong> {product.stock}
            </p>
            <p>
              <strong>SKU:</strong> {product.SKU || "N/A"}
            </p>
            <p>
              <strong>Description:</strong>{" "}
              {getShortDescription(product.description)}
              {!showFullDescription &&
                product.description?.split(" ").length > 50 && (
                  <span
                    onClick={() => setShowFullDescription(true)}
                    style={{ color: "#007bff", cursor: "pointer" }}
                  >
                    See More
                  </span>
                )}
            </p>
            <div className="d-flex align-items-center mt-3">
              <Button
                variant="primary"
                className="ml-3"
                onClick={() => navigate(`/create-order/${product.id}`)}
              >
                Buy Now
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProductQuickView;
